import fetch from '../utils/fetch'
export function getPcItemsList (query) {
  return fetch({
    url: '/h5app/wxapp/goods/items?company_id=1',
    method: 'get',
    params: query
  })
}




// WEBPACK FOOTER //
// ./src/api/pcgoods.js